import { render, staticRenderFns } from "./PromoDetailsImage.vue?vue&type=template&id=6c81a79a"
import script from "./PromoDetailsImage.vue?vue&type=script&lang=js"
export * from "./PromoDetailsImage.vue?vue&type=script&lang=js"
import style0 from "./PromoDetailsImage.vue?vue&type=style&index=0&id=6c81a79a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports